import { useAuth, useClerk } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { setClerkTokenGetter } from './clerkTokenBridge';
import { setLoginPromptOpener } from './loginRequired';

function currentReturnUrl(): string {
  return typeof window !== 'undefined' ? window.location.href : '/';
}

/**
 * Bridges Clerk's useAuth() hook (React-only) to the module-scope
 * tokenGetter ref consumed by RTK Query's fetchBaseQuery prepareHeaders,
 * and Clerk's openSignUp() to the `login_required` fallback (A.6.6c) so a
 * base query can open the sign-up modal.
 * Must render inside <ClerkProvider>.
 */
export function ClerkTokenSync() {
  const { getToken } = useAuth();
  const { openSignUp } = useClerk();
  useEffect(() => {
    setClerkTokenGetter((options) => getToken(options));
    return () => setClerkTokenGetter(null);
  }, [getToken]);
  useEffect(() => {
    setLoginPromptOpener(() => {
      const returnUrl = currentReturnUrl();
      void openSignUp({ forceRedirectUrl: returnUrl, signInForceRedirectUrl: returnUrl });
    });
    return () => setLoginPromptOpener(null);
  }, [openSignUp]);
  return null;
}
